module.exports = __webpack_public_path__ + "img/icon_private_overview01.1911b0e8.svg";